module.exports = __webpack_public_path__ + "img/iglu.7f28ee41.jpg";